import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { kycCompletedStyles } from './KYCCompleted.styles';
import { KYC_STATUS_VARIANTS } from 'constants/kycStatusVariants';
import { KYCConstants } from 'constants/application';

const checkmarkPath = "M75.1743 34.1417L46.514 69.977L24 51.2131L28.2479 46.1156L45.5582 60.5386L69.9971 30L75.1743 34.1417V34.1417Z";

export function KYCCompleted({ hasGstCertificate, nameMatched }: { hasGstCertificate?: boolean; nameMatched?: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const info = useSelector((state: any) => state?.info?.allData);

  useEffect(() => {
    if (!info?.customerId) {
      navigate('/', { replace: true });
    }
  }, []); // eslint-disable-line

  const showGstMessage = KYCConstants.ENABLE_GST_SECTION && hasGstCertificate && nameMatched === false;

  const subtitle = showGstMessage
    ? t('kyc_submitted_review_message', { defaultValue: 'Your documents are under review, status will be updated shortly.' })
    : info?.kycStatus === KYC_STATUS_VARIANTS.VERIFIED_NOT_SUBMITTED
      ? t('kyc_done_text_message2', { defaultValue: 'KYC process completed! Your status will be updated shortly.' })
      : t('kyc_done_text', { defaultValue: 'Thank you for completing your KYC. Please close this window' });

  const title = showGstMessage
    ? t('kyc_details_submitted', { defaultValue: 'KYC Details Submitted' })
    : t('kyc_complete', { defaultValue: 'KYC Completed' });

  const isVerifiedKyc =
    info?.kycStatus === KYC_STATUS_VARIANTS.VERIFIED ||
    info?.kycStatus === KYC_STATUS_VARIANTS.VERIFIED_NOT_SUBMITTED;

  return (
    <Box sx={kycCompletedStyles.root(isVerifiedKyc)}>
      <Box sx={kycCompletedStyles.content(isVerifiedKyc)}>
        <Box sx={kycCompletedStyles.iconWrap}>
          <svg fill="none" viewBox="0 0 100 100">
            <circle cx="50" cy="50" fill="#007CBF" r="50" />
            <path clipRule="evenodd" d={checkmarkPath} fill="white" fillRule="evenodd" />
          </svg>
        </Box>
        <Box sx={kycCompletedStyles.textWrap}>
          <Typography sx={kycCompletedStyles.title}>
            {title}
          </Typography>
          <Typography sx={kycCompletedStyles.subtitle}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
